import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { RequestResetPassword } from "@/app"

export const Route = createFileRoute("/(public)/auth/reset-password/")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Reset Password" }) }),
})

function RouteComponent() {
  return <RequestResetPassword />
}
